import { render, staticRenderFns } from "./info.vue?vue&type=template&id=4de153da&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de153da')) {
      api.createRecord('4de153da', component.options)
    } else {
      api.reload('4de153da', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=4de153da&", function () {
      api.rerender('4de153da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/empty-cartridge-production-orders/info.vue"
export default component.exports